module.exports = __webpack_public_path__ + "img/5a2d65d577ca102fcaacd833a41cf3b4.5542eff6.jpg";